module.exports = __webpack_public_path__ + "static/img/about-us_pic2@2x.5698c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_us/about-us_pic2@2x.jpg
// module id = 432
// module chunks = 0